module.exports = __webpack_public_path__ + "49e688cd96df3ee21508c7abcac33fd8.woff";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/TiemposTextWeb-BoldItalic.woff
// module id = 1102
// module chunks = 0